module.exports = __webpack_public_path__ + "static/media/ben-logo-footer.151a18c6.svg";